export class Endpoint {
    public static LEAD_MICROSERVICE: string = "https://lead-management-service-efcybtoxoa-uc.a.run.app";
    public static ADMIN_CONFIG_MICROSERVICE: string = "https://admin-config-nest-efcybtoxoa-uc.a.run.app";
    public static CUSTOMER_MICROSERVICE: string = "https://customer-management-service-efcybtoxoa-uc.a.run.app";
    public static DOCUMENT_MICROSERVICE: string = "https://document-management-service-efcybtoxoa-uc.a.run.app";
    public static BENEFICIARY_MICROSERVICE: string = "https://beneficiary-management-service-efcybtoxoa-uc.a.run.app";    
    public static USER_MICROSERVICE: string = "https://user-management-service-efcybtoxoa-uc.a.run.app";
    public static CASE_MICROSERVICE: string = "https://case-management-service-efcybtoxoa-uc.a.run.app";
    public static ATTORNEY_MICROSERVICE: string = "https://attorney-service-efcybtoxoa-uc.a.run.app";
    public static CLOUD_FUNCTIONS: string = "https://us-central1-lawtrax-prod.cloudfunctions.net";
    public static COMMON_MICROSERVICE: string = "https://common-service.lawtrax.com"; 
}
